export enum ConfigurationKeyNamesEnum {
  WorkOfficeAdminWorkflowsTable = 'WorkOfficeAdminWorkflowsTable',
  WorkOfficeAdminEnergieversorgerOrtschaftenTable = 'WorkOfficeAdminEnergieversorgerOrtschaftenTable',
  WorkOfficeFinanzenBudgetAuswertungenTable = 'WorkOfficeFinanzenBudgetAuswertungenTable',
  WorkOfficeArtikelPreiseTable = 'WorkOfficeArtikelPreiseTable',
  WorkOfficeArtikelTable = 'WorkOfficeArtikelTable',
  WorkOfficeArtikelAuswaehlenTable = 'WorkOfficeArtikelAuswaehlenTable',
  WorkOfficeArtikelUebersichtTable = 'WorkOfficeArtikelUebersichtTable',
  WorkOfficeAuswertungenArtikelLagerbestand = 'WorkOfficeAuswertungenArtikelLagerbestand',
  WorkOfficeAuswertungenAusstehendeAufgabenTable = 'WorkOfficeAuswertungenAusstehendeAufgabenTable',
  WorkOfficeMandantenExterneTerminaenderungenTable = 'WorkOfficeMandantenExterneTerminaenderungenTable',
  WorkOfficeAuswertungenFinanzenAbgrenzungen = 'WorkOfficeAuswertungenFinanzenAbgrenzungen',
  WorkOfficeAuswertungenFinanzenNochNichtFakturierteLeistungen = 'WorkOfficeAuswertungenFinanzenNochNichtFakturierteLeistungen',
  WorkOfficeFinanzenDebitoren = 'WorkOfficeFinanzenDebitoren',
  WorkOfficeFinanzenDebitorenFehlendeTeile = 'WorkOfficeFinanzenDebitorenFehlendeTeile',
  WorkOfficeFinanzenDebitorenKleiv = 'WorkOfficeFinanzenDebitorenKleiv',
  WorkOfficeFinanzenDebitorenZahlungseingaenge = 'WorkOfficeFinanzenDebitorenZahlungseingaenge',
  WorkOfficeAuswertungenLeadconversionTable = 'WorkOfficeAuswertungenLeadconversionTable',
  WorkOfficeAuswertungenMitarbeiterAbsenzenTable = 'WorkOfficeAuswertungenMitarbeiterAbsenzenTable',
  WorkOfficeAuswertungenMitarbeiterLohnlisteTable = 'WorkOfficeAuswertungenMitarbeiterLohnlisteTable',
  WorkOfficeAuswertungenMitarbeiterSaldouebersichtTable = 'WorkOfficeAuswertungenMitarbeiterSaldouebersichtTable',
  WorkOfficeAuswertungenMitarbeiterSaldouebertragTable = 'WorkOfficeAuswertungenMitarbeiterSaldouebertragTable',
  WorkOfficeAuswertungenMitarbeiterStundenauszugTable = 'WorkOfficeAuswertungenMitarbeiterStundenauszugTable',
  WorkOfficeAuswertungenPerformanceKundenberaterTable = 'WorkOfficeAuswertungenPerformanceKundenberaterTable',
  WorkOfficeAuswertungenPerformanceMontage = 'WorkOfficeAuswertungenPerformanceMontage',
  WorkOfficeAuswertungenUmsatzDeckungsbeitrag = 'WorkOfficeAuswertungenUmsatzDeckungsbeitrag',
  WorkOfficeBetriebsmittelLogbuchTable = 'WorkOfficeBetriebsmittelLogbuchTable',
  WorkOfficeBetriebsmittelLogbuchTypenTable = 'WorkOfficeBetriebsmittelLogbuchTypenTable',
  WorkOfficeBetriebsmittelTable = 'WorkOfficeBetriebsmittelTable',
  WorkOfficeEinkaufAnlieferungenAlleTable = 'WorkOfficeEinkaufAnlieferungenAlleTable',
  WorkOfficeEinkaufAnlieferungenWocheBoard = 'WorkOfficeEinkaufAnlieferungenWocheBoard',
  WorkOfficeEinkaufBestellungenTable = 'WorkOfficeEinkaufBestellungenTable',
  WorkOfficeEinkaufZuBestellenFilter = 'WorkOfficeEinkaufZuBestellenFilter',
  WorkOfficeElektroDrittkontrolleTable = 'WorkOfficeElektroDrittkontrolleTable',
  WorkOfficeGeruestbauTable = 'WorkOfficeGeruestbauTable',
  WorkOfficeFerienkalender = 'WorkOfficeFerienkalender',
  WorkOfficeKontakteTable = 'WorkOfficeKontakteTable',
  WorkOfficeLagerorteTable = 'WorkOfficeLagerorteTable',
  WorkOfficeMitarbeiterStundenuebersichtTable = 'WorkOfficeMitarbeiterStundenuebersichtTable',
  WorkOfficeMitarbeiterTable = 'WorkOfficeMitarbeiterTable',
  WorkOfficeMontageplanBacklog = 'WorkOfficeMontageplanBacklog',
  WorkOfficeMontageplanBacklogIntroSeen = 'WorkOfficeMontageplanBacklogIntroSeen',
  WorkOfficeMontageplanBlockDisplay = 'WorkOfficeMontageplanBlockDisplay',
  WorkOfficeMontageplanTeams = 'WorkOfficeMontageplanTeams',
  WorkOfficeMontageplanTeamsExpandedState = 'WorkOfficeMontageplanTeamsExpandedState',
  WorkOfficeMontageplanTeamSort = 'WorkOfficeMontageplanTeamSort',
  WorkOfficeMontageplanUnplannedBlocksProjectsTable = 'WorkOfficeMontageplanUnplannedBlocksProjectsTable',
  WorkOfficeMontageplanUnplannedBlocksTasksTable = 'WorkOfficeMontageplanUnplannedBlocksTasksTable',
  WorkOfficeMontageplanWeekOverviewTeams = 'WorkOfficeMontageplanWeekOverviewTeams',
  WorkOfficeMontageplanZoom = 'MontageplanZoom',
  WorkOfficeProjekteArbeitsstunden = 'WorkOfficeProjekteArbeitsstunden',
  WorkOfficeProjekteAufgabenTable = 'WorkOfficeProjekteAufgabenTable',
  WorkOfficeProjekteFotos = 'WorkOfficeProjekteFotos',
  WorkOfficeProjekteTable = 'WorkOfficeProjekteTable',
  WorkOfficeScreenFolienTable = 'WorkOfficeScreenFolienTable',
  WorkOfficeScreenGeraeteTable = 'WorkOfficeScreenGeraeteTable',
  WorkOfficeScreenKomponentenTable = 'WorkOfficeScreenKomponentenTable',
  WorkOfficeTicketsBoard = 'WorkOfficeTicketsBoard',
  WorkOfficeTodosBoard = 'WorkOfficeTodosBoard',
  WorkOfficeTicketsTable = 'WorkOfficeTicketsTable',
  WorkOfficeVeranstaltungenTable = 'WorkOfficeVeranstaltungenTable',
  WorkOfficeDashboardWidgetConfig = 'WorkOfficeDashboardWidgetConfig',
  WorkOfficeDashboardWidgetVerkaufUndUmsatzContainertypeId = 'WorkOfficeDashboardWidgetVerkaufUndUmsatzContainertypeId',
  WorkOfficeDashboardWidgetPrognostizierterUmsatzContainertypeId = 'WorkOfficeDashboardWidgetPrognostizierterUmsatzContainertypeId',
  WorkOfficeProjekteKarteFilter = 'WorkOfficeProjekteKarteFilter',
  WorkOfficeAkquiseReservationenFilter = 'WorkOfficeAkquiseReservationenFilter',
  WorkOfficeAkquiseobjekteTable = 'WorkOfficeAkquiseobjekteTable',
  WorkOfficeInaktiveProjekteAufraeumenKundenberater = 'WorkOfficeInaktiveProjekteAufraeumenKundenberater',
  WorkOfficeProjekteOhneGebautDatumProjektleiter = 'WorkOfficeProjekteOhneGebautDatumProjektleiter',
  WorkOfficeProjekteOhneInbetriebnahmeDatumProjektleiter = 'WorkOfficeProjekteOhneInbetriebnahmeDatumProjektleiter'
}
